import React from 'react';
import {useEffect, useState} from 'react';
import {useParams} from "react-router-dom";
import './ShrinePlaneStyle.scss';
import {RWebShare} from "react-web-share";
import {Load_News, Save_News} from '../NewsList/NewsService.tsx';
import {News2} from '../../Entities/News2.ts'
import Slider from "../Slider/Slider.tsx";
import {IconButton} from "@mui/material";
import {Edit, Save, Share} from "@mui/icons-material";
import {Row, Col} from 'react-bootstrap/esm';
import IranSanse from "../Typography/IranSanse.tsx";
import FloatIcon from "../FloatIcon/FloatIcon.tsx";
import HtmlEditor from "../HtmlEditor/HtmlEditor.tsx";


export default () => {
    const {id} = useParams();
    const [news, setNews] = useState(new News2());
    const [ReadMode, setReadMode] = useState(true);
    let icon = ReadMode ? <Edit></Edit> : <Save></Save>
    useEffect(() => {
        // ShrineNewsService();
        Load_News(id).then(r => {
            setNews(r)
            console.log(r);
        });
    }, [id])


    return (
        <div className='col-12  px-5'>
            <div className='ShrinePlaneDetailPage' style={{fontFamily: 'iranSanse-bold2'}}>
                <Row className='pt-3 g-0'>
                    <Col className='text-end' style={{paddingRight: 0}}>
                        <h4 className='pt-2'>{news?.Title}</h4>
                        <div className='d-flex '>
                        <span className='text-black text-end text-muted'
                              style={{cursor: 'auto'}}><IranSanse>{news?.hour}</IranSanse></span>

                            <span className='text-black d-flex justify-content-end mx-3 text-muted '
                                  style={{cursor: 'auto'}}><IranSanse>{news?.shamsi}</IranSanse></span>
                        </div>
                    </Col>
                    <Col className=''>
                        <Row className='g-0'>
                            <Col>
                                <div className='text-black d-flex justify-content-end'>
                                    <RWebShare
                                        data={{
                                            url: window.location.href,
                                            title: news?.Title,
                                        }}
                                    >
                                        <IconButton variant="solid" size={"small"}>
                                            <Share fontSize={"medium"} color={"action"}/>
                                        </IconButton>

                                    </RWebShare>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col>

                            </Col>
                        </Row>
                        <Row>
                            <Col>

                            </Col>
                        </Row>

                    </Col>
                </Row>
                <Row className='py-2 g-0' style={{fontFamily: 'iranSanse-bold2'}}>
                    <Col>
                        <span>{news?.SubTitle}</span>
                    </Col>
                </Row>
                <Row className='headerNews' style={{fontFamily: 'iranSanse-bold2'}}>

                </Row>
                <Row>
                    <Col md={12} className='justify-content-center d-md-flex'>
                        <div className='news-content col-sm-12 col-md-8 col-lg-6 col-xl-6 col-xxl-6 mt-4'>
                            {/*<img className='col-12' src={`${fileManager}${news?.pictureId}`} alt=""/>*/}
                            <div className='sliderContainer' style={{width: '100%'}}>
                                <Slider ImageHeight={'350px'} sliderData={[{
                                    "title": " ",
                                    "pictureId": news.pictureId
                                }]}></Slider>
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <HtmlEditor className='justify-content-center d-flex pt-4' ReadMode={ReadMode}
                                    OnChange={(html) => {
                                        news.Text = html
                                        setNews(news)
                                        console.log(html);
                                    }}
                                    Text={news?.Text ?? ""}
                        />

                        {/*    /!*{news?.Text ? parse(news?.Text) : ""}*!/*/}
                        {/*</HtmlEditor>*/}
                    </Col>
                </Row>
                {/*<div className='news-content col-md-10 col-11 mt-md-4 mt-4'>*/}
                {/*    <span>برای تست</span>*/}
                {/*</div>*/}
            </div>
            <FloatIcon onClick={() => {
                {
                    if (!ReadMode) {
                        Save_News(news).then((r) => {
                            console.log(news);
                            setNews(r);
                            console.log(r);
                            console.log(news);
                            setReadMode(true)
                        });
                    } else {
                        setReadMode(false);
                        console.log(ReadMode);
                    }

                    console.log(ReadMode);
                }
            }}>
                {ReadMode ? <Edit></Edit> : <Save></Save>}
            </FloatIcon>
        </div>
    )
}

